import { WeekDateEnum, WeekDateEsEnum } from '@core/enums';

export function weekDateByIndex(index: number): WeekDateEnum {
	const keys = Object.keys(WeekDateEnum) as (keyof typeof WeekDateEnum)[];
	return WeekDateEnum[keys[index]];
}

export function toWeekDate(day: string | null | undefined): WeekDateEnum | null {
	if (!day) return null;
	const normalizedDay = day.toLowerCase();

	if ((Object.values(WeekDateEnum) as string[]).includes(normalizedDay)) {
		return normalizedDay as WeekDateEnum;
	}

	const spanishDay = (
		Object.keys(WeekDateEsEnum) as (keyof typeof WeekDateEsEnum)[]
	).find(key => {
		const normalizedSpanishDay = WeekDateEsEnum[key]
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();

		return (
			WeekDateEsEnum[key].toLowerCase() === normalizedDay ||
			normalizedSpanishDay === normalizedDay
		);
	});

	return spanishDay ? WeekDateEnum[spanishDay] : null;
}

export function toDateStr(
	value: string | Date | null | undefined,
	end: number,
	start = 0
): string | null {
	if (!value) return null;
	return typeof value === 'string' ? value : value.toISOString().slice(start, end);
}

export function isDateRangeActive(
	range: {
		rangoFechaInicio: string | null;
		rangoFechaFin: string | null;
		horaInicio: string | null;
		horaFin: string | null;
	},
	now: Date
): boolean {
	if (range.rangoFechaInicio && range.rangoFechaFin) {
		const startDate = new Date(range.rangoFechaInicio);
		const endDate = new Date(range.rangoFechaFin);
		if (now < startDate || now > endDate) return false;
	}

	return isTimeRangeActive(range.horaInicio, range.horaFin, now);
}

export function isAssociatedDayActive(
	day: {
		nombreDia: string | null;
		habilitado: boolean | null;
		horaInicio: string | null;
		horaFin: string | null;
	},
	now: Date
): boolean {
	if (!day.habilitado || toWeekDate(day.nombreDia) !== weekDateByIndex(now.getDay())) {
		return false;
	}

	return isTimeRangeActive(day.horaInicio, day.horaFin, now);
}

function isTimeRangeActive(
	startTime: string | null,
	endTime: string | null,
	now: Date
): boolean {
	if (!startTime || !endTime) return true;

	const [startHour, startMinute] = startTime.split(':').map(Number);
	const [endHour, endMinute] = endTime.split(':').map(Number);
	const currentMinutes = now.getHours() * 60 + now.getMinutes();
	const startMinutes = startHour * 60 + startMinute;
	const endMinutes = endHour * 60 + endMinute;

	if (startMinutes <= endMinutes) {
		return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
	}

	return currentMinutes <= endMinutes || currentMinutes >= startMinutes;
}
